export default [
   {
      path: '/marketforecast',
      component: () => import ( '@/views/weekforecast/marketforecast/BscMarketForecastWeekYield.vue'),
      meta: {
         title: '市场周预测',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/productionforecast',
      component: () => import ( '@/views/weekforecast/productionforecast/BscProductionForecastDayYield.vue'),
      meta: {
         title: '生产周预测',
         isTabsPage: true,
         keepAlive:true
      }
   }
]
